import { createLength, lengthToMiles, lengthToKilometres, LengthUnit } from 'measure-fns';

export const convertDistance = (kilometres: number, unit: string | undefined): string => {
  const resolvedUnit = unit ?? 'ft';
  const distance = createLength(kilometres, LengthUnit.kilometres);
  switch (resolvedUnit) {
    case 'ft':
      return `${new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(
        lengthToMiles(distance, { round: 1 }),
      )} miles`;
    case 'm':
      return `${new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(
        lengthToKilometres(distance, { round: 1 }),
      )} kilometres`;
    default:
      throw new Error(`Unsupported unit: ${resolvedUnit}`);
  }
};
